import { Model } from 'vuex-orm';

import AppMembership from '../appMembership/model';
import User from '../user/model';

export default class Company extends Model {
  static entity = 'companies';

  static fields() {
    return {
      id: this.attr(null),
      uuid: this.attr(''),
      name: this.attr(''),
      address: this.attr(''),
      address2: this.attr(''),
      city: this.attr(''),
      state: this.attr(''),
      zip: this.attr(''),
      country: this.attr(''),

      app_memberships: this.hasMany(AppMembership, 'company_id'),
      users: this.hasMany(User, 'company_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company/model.js